const LilDujourAllReleasesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/0YHNqTEXdkHFzPKxFYFOn9?si=73f280f6e6424081" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - $tre$$ (feat. Lil Dujour)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Mixtape</p>
            <a href="https://soundcloud.com/dujourmusic/hellscape-presentslil-dujour" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-1rSSZehbsTvFfCFp-eqi6Hw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>HELLSCAPE PRESENTS... LIL DUJOUR</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/kawaii-ry-dujour-this-my-last-one-but-i-can-break-it-down-in-half" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-CX8LoV5NILXcG9lS-aEpOTw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lil Dujour & Kawaii Ry - This My Last One But I Can Break It Down In Half</strong><br/>
                (prod. Mista)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/kawaii-ry-lil-dujour-conceited" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-z7hfX094yoqjG26P-FJhglg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lil Dujour & Kawaii Ry - Conceited</strong><br/>
                (prod. Lil Dujour)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/2good4unot-like-us-remix" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-6CBMFzupiHTUoZwL-ghbyxg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>2GOOD4U (NOT LIKE US REMIX)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/stop-rappingparesden" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-QVcLbDFGN82rFEQf-Dvl8qQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Stop Rapping</strong><br/>
                (prod. aresden)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/traceprodsl4yyer" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-TsjGamsu5Zzy4UoQ-uRW5UA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>TRACE</strong><br/>
                (prod. sl4yyer!)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/stampedwitanmprodsohi" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-ymy6k9IDpxlMODFT-0fIeyA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>StampedWitAnM</strong><br/>
                (prod. SoHi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/if-its-me-or-u-its-me-every-time-ft-kawaii-ryprod1awesome" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-kdY8Ehe36GlVyqS1-t8JCAA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>If Its Me Or U Its Me Every Time (feat. Kawaii Ry)</strong><br/>
                (prod. 1awesome)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3IAym27cx48RClaaVPghKA?si=b9532f9724fe412c" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Battle Bus (feat. Lil Dujour)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/i-feel-like-theres-a-nicer-way-to-ask-prod-1ndone-mardee" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ptXnO5wDogoyQen9-Vzh6Pg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>I FEEL LIKE THERES A NICER WAY TO ASK</strong><br/>
                (prod. 1ndone & Mardee)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/letsgetsickprodanvil" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Wk987AgD8fLBvWFy-qZqk2A-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LETSGETSICK</strong><br/>
                (prod. Anvil)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6jkVXtqAatXCciYkkUU1yF?si=65e806776417457b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xSP18AVFYaNF6ukw-HQPBuA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WITHDRAWLS ARE MY FAV</strong><br/>
                (prod. Curtains)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/00RQ7bxHieKs2cuH1DzVzD?si=bdda841b9af64dc1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xSP18AVFYaNF6ukw-HQPBuA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ONE ONE THOUSAND TWO ONE THOUSAND</strong><br/>
                (prod. Flowrency)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3LBUbdip55nDstvXyD68yu?si=5cfc377f10064359" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xSP18AVFYaNF6ukw-HQPBuA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>NOTICE ME SENPAI NOTICE ME</strong><br/>
                (prod. 30NICKK)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/32TpKSxW3ylSXairn1J24D?si=c6b9bfa639ce49c1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xSP18AVFYaNF6ukw-HQPBuA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>THEY KILLIN NIGGAS OVER COLD FRIES BRO</strong><br/>
                (prod. JDOLLA)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/the-scene-kids-say-nigga-when-noone-else-around-prodlilbextz" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-z8tHozQFrgSGQmty-V1TbCw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>THE SCENE KIDS SAY NIGGA WHEN NOONE ELSE AROUND</strong><br/>
                (prod. Lil Bextz)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4WXC1oS2kvZmv8ic8nNLt8?si=d9d4c92e05a5466b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-cKbogsj8VMEx2uWD-j9yG9Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Some Foil, Some Blues & A Lighter</strong><br/>
                (prod. FLANSIE)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5UGUTAzPHHHN4QEzx3dWec?si=e71be18cafdf4a25" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-cKbogsj8VMEx2uWD-j9yG9Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>The Last Good Thing On This Sorry Side of Town</strong><br/>
                (prod. 1georgie)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5YtnoddFbHo9WaGVU8Ih7y?si=0d9ac54b03a840be" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-cKbogsj8VMEx2uWD-j9yG9Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Im Pete Wentz & These Are The Fall Out Boys</strong><br/>
                (prod. MISTA)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/mf-dujour-accordian-freestyle" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-doskvHBBLrQgrBHb-dcJb5g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>MF DUJOUR -Accordian Freestyle</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5WcMFgBGwAprkavtzpgT0d?si=d7750df71d3e4001" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-KSDnl3ihOK4mzmJM-n6cKLQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Dujour Speaks (feat. Lil Dujour)</strong><br/>
                (prod. Meauxminy & Geist)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6QlbqOSnv6PNS1KAyxxgaO?si=c45085a8052f453c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Health</strong><br/>
                (prod. Flexer)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2itK6ULTjbBl68JjWBiBMq?si=e5885dabd7c846ba" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Glib</strong><br/>
                (prod. AltoSGP)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0uP2SSjEfWo9IFLiX9gnFp?si=94d4c7df0426400c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Sincerely Yours</strong><br/>
                (prod. Lexani)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/56Hc80l9w8dWbyh5a8gbYz?si=235882bd10a64bba" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>You Think You're Anxious? Get a Load of This Guy</strong><br/>
                (prod. Oscar4400xy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5Lod24aI9DZEayTPCEhlOs?si=694e888921174091" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Obvi (feat. CATXSCAN)</strong><br/>
                (prod. B2)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6CmVNzFo4jy8cRFgdSOUHg?si=de8155362aad476a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Daft Punk</strong><br/>
                (prod. Lil Dujour)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/56dAeaxODtJqbQRWBRM7Ky?si=e652abd2c95e4992" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Eight</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7dtjoLiYXReir3gPEsgP7M?si=38adcedc0b624663" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>All We Want</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4uDQk2RSTsZlP5KokqB5Pl?si=b9cd683f1d474c94" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Cuzzo</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/04agkUjwQdstSaK6V2tN3y?si=04daae1b9f0d4dce" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Obama</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6qqaCYa5dW3VpxUH40dC8h?si=71ca816dd740459c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Like This</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2Mnzl8mgPSYASFACO0Fha8?si=078ba4d183fc403b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Cant Eat</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0bq2RFlN223oYOEzm9vi8v?si=84bfb003ba2d4951" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e022237649dac155888cfd8412a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PINK</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5ynWS72UYRV256giayxoRe?si=487053748f9d4fe6" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e022237649dac155888cfd8412a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LOL (feat. Killtheheretik)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2toRA89ZgTebOdPpGuKvZC?si=725593d998e64f61" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e022237649dac155888cfd8412a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Your Favorite Weapon</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/60mfrJ1g61MdoqILwgpv9B?si=ad89bbb689f9427a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e022237649dac155888cfd8412a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Attitude</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6Ss9H8tTU03AsfBhUzVLNO?si=4134a35e5d8d4bbb" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e022237649dac155888cfd8412a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>No Tylenol (feat. Piecsa)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2nUaOwUAMVJj92LGBdgdmM?si=8faa2637877d4aa3" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yeah Me Too</strong><br/>
                (prod. Lil Bextz & Thislandis)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/26EP5HRcfzht4daT3xe6pb?si=ea3517ad9d324992" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loot</strong><br/>
                (prod. XANGANG)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4NjiehI23Y0oOn1WckhXcw?si=408a90a8965e4451" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Not Fair</strong><br/>
                (prod. keyblade808)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/26CsegYU02n6HEUuLs4YKk?si=2cd5713730374742" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Sick</strong><br/>
                (prod. Dani Kyoto & MON)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0DaUXrKakCqBh3hiVAQ7Y6?si=fae394da29a6461a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Risk (feat. Kiari Stone)</strong><br/>
                (prod. TCHNO)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0uU7Ud9INT256Ao8OB1JCW?si=ee5011a54e7c4118" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Type of Type</strong><br/>
                (prod. Oscar4400xy & CashHeart)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6GYiraElVupxxbFXQ9uo6Q?si=e401091d096e4469" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Two More</strong><br/>
                (prod. ENRGY)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4vhXfwAeXnceI8UpS5SMIA?si=d3c31d8a98d2450c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Oops</strong><br/>
                (prod. Taylor Morgan)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4g8eiJTxqb5j7ODYqYjGvW?si=ea642c21584a42e8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>I Dont Like To Tour</strong><br/>
                (prod. BRENTRAMBO)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6mn9QkqSnseAMBTAAH66LO?si=4af0123bb7eb4733" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Safe (feat. air everyneeds)</strong><br/>
                (prod. Anvil)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0nMK0xHt6VCpk663HpFgyM?si=fa0b027757dd4712" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Quote Us</strong><br/>
                (prod. Skress & Mochila)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/77OEJWoQRI6zTKZb0Z79m9?si=91e20f6928a944a9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Charmed</strong><br/>
                (prod. BRENTRAMBO)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7DFnm1r9fuw7RGh48B2JRh?si=f679d256a9c64a22" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Cribs</strong><br/>
                (prod. 30NICKK)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7lRt8o95vcuWrrF3Ju7Yv8?si=993ff0b58c724e5d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>True (feat. nolovedoza)</strong><br/>
                (prod. 6houl)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1Ob4j3Nf17evoJtMOYqtco?si=13c8eefd583b4e4d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-AhZo8V9cip4n0J8c-jyvsTA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Horses</strong><br/>
                (prod. Anvil)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/girlswantdrugsgirlswantgirls-freestyle" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wS56nnss9UH6UVKK-3rIqWA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>GirlsWantDrugs(GirlsWantGirls Freestyle)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/2geekedupdrake-way-2-sexy-freestyle" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qKpK97U9vrNsFI7y-s0SMKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>2GeekedUp!(Drake Way 2 Sexy Freestyle)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7ADPm5zKSdGZlEwVUVNQS6?si=4ba764c3e2ba4286" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>CECE</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/09adcUxpq4D6l7xnuqjFY6?si=e7f4639b1dc54cc2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>KEANO</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4A10t3QbgZMtgMKYIgj6n6?si=4f453195192d4875" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ZERO</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1Qvh6sS7Z7HXnRwfAYWezB?si=b38ed24d0ddc4db7" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ZENDAYA</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6PCrLD6dUv8Fr4D9hBPoMU?si=8fe2c6e9d0d24fe8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>KAI (feat. Big Homie Stone)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2bv0zmqUFPftYwvLm7BsGG?si=776bf4606f8c4189" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>CHELSEY</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7qeHCtEYhWje2hUq78UHF5?si=dd2f166c6f1845fc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PASTELLE</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7LklZ2szUrT6DlRFeTOSim?si=b09aafc1a6884d34" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-SRXfoa59wlkrXuLc-dAt4gA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lil Dujour - Straight 100</strong><br/>
                (prod. MDST)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5lU2ywtwxc83uIAB90BUKz?si=233ced73afeb47c8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-SRXfoa59wlkrXuLc-dAt4gA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lil Dujour - State 2 State</strong><br/>
                (prod. Charlie Shuffler)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4LorRg9eTGXtOps9R10Av6?si=2cdee346287041c7" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-SRXfoa59wlkrXuLc-dAt4gA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lil Dujour - Roundabout</strong><br/>
                (prod. rossgossage)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1T220QwAqJRjLSiDfTI7Te?si=95d57ebd6acd489e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Los Angeles</strong><br/>
                (feat. Lil Dujour & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4qNn3LnOvarl3XqrOkoJWk?si=bf183cb7f04643b4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Hollywood Money</strong><br/>
                (feat. Lil Dujour, Sketchtheheathen & Rosie Grave)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/0SfqdQ0oeemdtmNvYgMkWc?si=825c8d441a7d429b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - City Moves</strong><br/>
                (feat. Lil Dujour, Zerow & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5mR9mkhJrHjdvKIL3Auow5?si=0798c6091b404175" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Crying on Melrose</strong><br/>
                (feat. Lil Dujour & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7bVUcxEG7dwUb6g9L1AWjF?si=2e1f804f16994785" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Why You Do Me Like Dat??</strong><br/>
                (feat. Lil Dujour)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7pfaMhMrwlQ2WLxuHPiZTM?si=455e8ceab55c4ea5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Personals</strong><br/>
                (feat. Lil Dujour & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1T220QwAqJRjLSiDfTI7Te?si=d5bcb38cb66940a6" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Shakesum</strong><br/>
                (feat. Lil Dujour & Kewl Nast)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4N21qR6oV6xechdUj7PWRD?si=2a1f454a5ac247dc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-4zUzENh91AiOUYHZ-lfj4Hg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Killtheheretik - Glue (feat. Lil Dujour)</strong><br/>
                (prod. Halfblown)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/brat-prodbeanone" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ZpYwfRgFsSCEOQPq-gf0qFw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BRAT!</strong><br/>
                (prod. BeanOne)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/shawty-pt-2-screwedi-was-off-the-oxy-when-i-made-this-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-PbrFekAWyTFdeYxZ-uG8Gvw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SHAWTY PT 2 SCREWEDREMIX</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/whatsthematter-2022-nitecore-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-okOv7pQwUiaaSPV9-gzjrFg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WhatsTheMatter 2022 Nitecore REMIX</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1G9wfBsFdlhqLvufjbsAPS?si=602a7440282b4504" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02e1636759f4214070c4582b2f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - I Was Broke Last Weekend (feat. Lil Dujour)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3VXL1ws5Km1lqZlL6BteXb?si=7bde0fe58ff34fc9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Cruel Summer</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2oyo78dGYJlGxZ0qX4roQf?si=ad619cb33d6c452c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Blossom</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2LGB8lUs44xWBxiL3v93d9?si=000ebd0260dd4e75" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Amen</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6fRS2SVCuiCh2fvi2VvXDa?si=9ca46c4262ee4a29" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Beam Me Up</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5T0yxMCRxSIs5Vt4aciawa?si=d10bdf8507474ecd" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>What's the Matter</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1EXUUTWwNu6GXL7zY3j3IB?si=4ef5f06b70ec4cad" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Shawty</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2msEK4DiMI9Wg3V7Gaf4Rj?si=1c60703114314d5e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Shawty, Pt. 2</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6ux8UjycG6rWN7sUWmXMaq?si=f4fbc37fdce94d54" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-KtuyHLIf7uFb2yJN-RZsKsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Secrets</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/freeverse2018" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000579106739-tecfo5-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>FREEVERSE2018</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5C38fRRMG5anh1Z4Wc03iz?si=7311c79c093242fd" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000568942628-z5pk48-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Vampire</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/idontlike2fight2020-basedwrld-xclusive" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000552067743-1bhqnk-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IDONTLIKE2FIGHT(2020 BASEDWRLD XCLUSIVE)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5g4BEuZDATQ3inre5GHKBb?si=df3ed660e14c4e1b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000518110371-fn0ws4-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Pray 4 Lui</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0yRjy4FNHONq37Zg7pMvah?si=da283b3e100441ff" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000493368498-jcyl29-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Greed</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0GNgV13lIsYAiaiO9fGv08?si=334eac8c3dfe485d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000493368498-jcyl29-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>P.S.A.</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3N0Ya3RTZnlceXHSn5iGQ4?si=f95b00ac02af4e88" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000493368498-jcyl29-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Paramore</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5zMroeVyUgJrpOp0YtkJ6K?si=8693fce66c0f4e64" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000493368498-jcyl29-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Celine</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0kGgXiFMFWcRh0iYorQVzI?si=be00f34521ec4124" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000493368498-jcyl29-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Free Money</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/computerbluu" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000386667201-hl5idt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ComputerBluu</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/nothin-prodfishnarc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000386655420-yj5q3z-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Nothin'</strong><br/>
                (prod. Fish Narc)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/single" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000361388511-kjmffr-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>YouShouldHaveStayedSingle</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/dujourmusic/twoprodfishnarc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000348335961-r2md46-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>TWO</strong><br/>
                (prod. Fish Narc)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default LilDujourAllReleasesStatic;